export const environment = {
    apiBaseUrl: 'https://digify-lms-app-dev-api.digifyafricaserver.com/api/v1',
    production: false,
    serverBaseUrl: 'https://digify-lms-app-dev-api.digifyafricaserver.com',
    googleClientId: "766104386680-h117hpd79i1svi29il6jjcpopi17h95q.apps.googleusercontent.com",
    googleClientSecret: "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", 
    redirect_uris:["https://keycloak-lms-dev.digifyafricaserver.com","https://keycloak-lms-dev.digifyafricaserver.com/home"],
    keycloak_url: 'https://keycloak-lms-dev.digifyafricaserver.com',
    redirect_uri: 'https://digify-lms-app-dev.digifyafricaserver.com',
}